// The table set: Table wraps a real table in a horizontal scroll container,
// the rest are thin element wrappers. Th and Td take numeric to right-align
// with tabular figures. Row height and hover come from tokens. No sorting,
// no selection, no data awareness; screens own all of that.

import './table.css'

export function Table({ className = '', children, ...rest }) {
  return (
    <div className="ui-tablewrap">
      <table className={`ui-table${className ? ` ${className}` : ''}`} {...rest}>
        {children}
      </table>
    </div>
  )
}

export function Thead({ children, ...rest }) {
  return <thead {...rest}>{children}</thead>
}

export function Tbody({ children, ...rest }) {
  return <tbody {...rest}>{children}</tbody>
}

export function Tr({ className = '', children, ...rest }) {
  return (
    <tr className={className || undefined} {...rest}>
      {children}
    </tr>
  )
}

export function Th({ numeric = false, className = '', children, ...rest }) {
  return (
    <th
      className={`${numeric ? 'ui-td-num' : ''}${className ? ` ${className}` : ''}` || undefined}
      {...rest}
    >
      {children}
    </th>
  )
}

export function Td({ numeric = false, className = '', children, ...rest }) {
  return (
    <td
      className={`${numeric ? 'ui-td-num' : ''}${className ? ` ${className}` : ''}` || undefined}
      {...rest}
    >
      {children}
    </td>
  )
}
